import { EllipsisText } from 'canoe';
import { useFormikContext } from 'formik';
import React from 'react';

import { ContentPlacement } from '@candu-ai/placement/types';
import { CompletedStepSettings, EditLinkButton } from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { getPlacementUrlText } from 'craft/containers/Toolbox/tabs/Placements/utils';

interface Props {
  onEdit: VoidFunction;
}

export const HotspotGroupUrl = ({ onEdit }: Props) => {
  const { values } = useFormikContext<ContentPlacement>();

  const placementUrl = getPlacementUrlText(values);

  return (
    <CompletedStepSettings>
      <EllipsisText content={placementUrl}>
        <span dir="rtl">
          <bdi>
            <strong>{placementUrl}</strong>
          </bdi>
        </span>
      </EllipsisText>
      <EditLinkButton
        appearance="text"
        inline
        size="small"
        variant="white"
        fontWeight="xbold"
        onClick={onEdit}
      >
        edit
      </EditLinkButton>
    </CompletedStepSettings>
  );
};
